import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useMemo } from 'react';
import '../../_utils/components/InputError.module.scss.js';
import { InputLabel } from '../../_utils/components/InputLabel.js';
import { InputHintError } from '../../_utils/components/InputHintError.js';
import 'primereact/tooltip';

function InputWrapper(props) {
  const {
    wrapperClassName,
    labelClassName,
    inputClassName,
    errorClassName,
    horizontal,
    children,
    field,
    fieldState,
    id,
    label,
    hint,
    errorMessage: errorMessageProps,
    suffix,
    labelSuffix,
    focus,
    labelHidden,
    required,
    labelTooltip,
    suppressRequiredLabel,
    bulkMode
  } = props;
  const errorMessage = useMemo(() => {
    var _a;
    if (errorMessageProps) {
      return errorMessageProps;
    }
    if (((_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _a === void 0 ? void 0 : _a.type) === 'required') {
      return 'This field is required';
    }
  }, [errorMessageProps, fieldState === null || fieldState === void 0 ? void 0 : fieldState.error]);
  return jsxs("div", {
    className: clsx(wrapperClassName, 'input-wrapper', !horizontal ? 'input-wrapper--vertical' : 'input-wrapper--horizontal', !label ? 'missing-label' : null, !field ? 'uncontrolled' : null),
    children: [label ? jsx("div", {
      className: "input-wrapper__label",
      children: jsxs("div", {
        className: "input-wrapper__label-content",
        children: [typeof label === 'string' ? jsx(InputLabel, {
          field: field,
          label: label,
          id: id,
          labelHidden: labelHidden,
          labelClassName: labelClassName,
          horizontal: horizontal,
          required: required,
          labelTooltip: labelTooltip,
          suppressRequiredLabel: suppressRequiredLabel,
          bulkMode: bulkMode
        }) : label, labelSuffix ? jsx("div", {
          className: "input-wrapper__label-suffix",
          children: labelSuffix
        }) : null]
      })
    }) : null, jsxs("div", {
      className: clsx(suffix ? 'input-wrapper__input--suffix' : null, focus && suffix ? 'input-wrapper__input--suffix--focus' : null, 'input-wrapper__input', inputClassName),
      children: [children, suffix]
    }), jsx(InputHintError, {
      className: clsx('input-wrapper__hint-error', errorClassName),
      hint: hint,
      fieldState: fieldState,
      errorMessage: errorMessage
    })]
  });
}

export { InputWrapper };
